import { AddMailFormWrapper, AddMailTitle } from './styles'
import { useTranslation } from 'react-i18next'
import Select, { Option } from 'components/Select'
import Input from 'components/Input'
import UploadFile from 'components/UploadFile'
import DatePicker from 'components/DatePicker'
import SubmitButton from 'components/SubmitButton'
import { Domiciliation } from 'globals/models/Domiciliation'
import { MutationResult } from '@apollo/client'
import { CreateMailResult } from 'pages/AddMail/mutations'
import { FormikValues } from 'formik'
import Mail from 'globals/models/Mail'
import moment from 'moment'
import ImportantMail from 'components/ImportantMail'

interface IProps {
  domiciliation: Domiciliation
  values: FormikValues
  createMailData: MutationResult<CreateMailResult>
  selectedMail?: Mail | null
}

const AddMailForm = (props: IProps) => {
  const { domiciliation, values, createMailData, selectedMail } = props
  const { t } = useTranslation()

  return (
    <>
      {selectedMail ? (
        <AddMailTitle>
          Modifier un courrier de
          <br />
          <b>{domiciliation.society.name}</b>
        </AddMailTitle>
      ) : (
        <AddMailTitle>
          {t('mails.add.title')} <br />
          <b>{domiciliation.society.name}</b>
        </AddMailTitle>
      )}

      <AddMailFormWrapper>
        <Select name='type' label={t('mails.mail-type')} noBottomPadding required>
          <Option value='courrier'>{t('mails.types.courrier')}</Option>

          <Option value='delivery_notice'>{t('mails.types.delivery_notice')}</Option>

          <Option value='ar'>{t('mails.types.ar')}</Option>
        </Select>

        <ImportantMail text={t('mails.important-mail.text')} />
        {values.type === 'colis' && selectedMail?.mailType !== 'colis' && (
          <Input name='weight' label={t('mails.add.weight')} required />
        )}
        {selectedMail?.mailType === 'colis' && (
          <Input
            name='weight'
            label={t('mails.add.weight')}
            defaultValue={selectedMail.weight}
            key={`weight:${selectedMail.weight}`}
          />
        )}

        {values.type !== 'colis' &&
          domiciliation &&
          (domiciliation.userMailOption === 'scanning' ||
            domiciliation.userMailOption === 'scanning_and_destroy' ||
            domiciliation.userMailOption === 'scanning_and_forwarding' ||
            domiciliation.userMailOption === 'scanning_and_unrestricted_forwarding') && (
            <UploadFile name='scannedFile' label={t('mails.add.digital-file')} />
          )}

        {selectedMail ? (
          <Input
            name='sender'
            label={t('mails.sender')}
            placeholder='Ex: Laura Dupont'
            key={`sendName:${selectedMail.sendName}`}
            defaultValue={selectedMail.sendName}
          />
        ) : (
          <Input name='sender' label={t('mails.sender')} placeholder='Ex: Laura Dupont' />
        )}

        {selectedMail ? (
          <DatePicker
            name='receiptDate'
            label={t('mails.receipt-date-form')}
            placeholder={t('global.date-format')}
            defaultValue={moment(selectedMail.dateOfReceipt)}
            key={`dateOfReceipt:${selectedMail.dateOfReceipt}`}
          />
        ) : (
          <DatePicker
            name='receiptDate'
            label={t('mails.receipt-date-form')}
            placeholder={t('global.date-format')}
            defaultValue={values.receiptDate}
            required
          />
        )}

        <SubmitButton text={t('global.save')} loading={createMailData.loading} />
      </AddMailFormWrapper>
    </>
  )
}

export default AddMailForm
